"use strict";
var debounce = require("lodash/debounce");

/**
 * @function
 * @description function to apply the corresponding DIS source on video
 */
const videoResponser = () => {
    class VideoResponser {
        /**
         * Constructs a new instance of the class.
         * @param {string} selector - The CSS selector to select the video elements
         */
        constructor(selector) {
            const videoList = document.querySelectorAll(selector);
            videoList.forEach(function ($video) {
                $video.options = {
                    selector,
                    breakpoints: {}
                };

                // get a list of video switching points and links to the videos themselves
                $video.querySelectorAll("[data-src]").forEach(element => $video.options.breakpoints[element.getAttribute("data-mw")] = { src: element.getAttribute("data-src") });

                $video.innerHTML = "";

                // run the handler and track the change in screen width
                this.responseVideo($video);
                this.resizer();
            }, this);
        }

        /**
         * Resizes the video elements on window resize event
         * @returns {void}
         */
        resizer() {
            window.addEventListener("resize", debounce(() => {
                const videoList = document.querySelectorAll(".video-responser");
                videoList.forEach(function ($video) {
                    this.responseVideo($video);
                }, this);
            }), 100);
        }

        /**
         * @function
         * @description function to change src value of video link to fit screen width
         * @param {Object} options - object with options
         * @param {string} $defaultSource - default surce of the video, as a fallback
         */
        responseVideo($video) {
            let $defaultSource = $video.getAttribute("data-src");
            const {breakpoints} = $video.options; // get options
            const widthNow = $video.getAttribute("data-width-now") || null;
            const breakpoint = Math.max.apply(Math, Object.keys(breakpoints).filter(key => key <= document.body.clientWidth).map(Number));
            const nowBreakpoint = breakpoint;

            if (widthNow && widthNow == nowBreakpoint) return; // check if the video needs to be changed

            $video.setAttribute("data-width-now", nowBreakpoint);

            if (breakpoints[nowBreakpoint].src) {
                $video.src = breakpoints[nowBreakpoint].src;
            } else {
                $video.src = $defaultSource;
            }
        }
    }

    new VideoResponser(".video-responser");
};

module.exports = {
    videoResponser: videoResponser
};
